import { Phone, Mail, Award } from "lucide-react";
import { CONTACT } from "./data";

export default function Footer() {
  return (
    <footer className="relative bg-[#101317] border-t border-[#9AA3AF]/15 pt-16 pb-10">
      <div className="max-w-[1200px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img src="/markonlyvector.png" alt="Million-Air A/C & Heating" className="h-16 w-auto" />
            <p className="mt-5 text-[#9AA3AF] leading-relaxed max-w-xs">
              {CONTACT.serviceArea}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm tracking-[0.25em] uppercase text-[#C9A44C] mb-5">Contact</h4>
            <a data-testid="footer-phone" href={CONTACT.phoneHref} className="flex items-center gap-3 text-white hover:text-[#C9A44C] transition-colors duration-300 mb-3">
              <Phone size={18} className="text-[#C9A44C]" /> {CONTACT.phone}
            </a>
            <a data-testid="footer-email" href={CONTACT.emailHref} className="flex items-center gap-3 text-white hover:text-[#C9A44C] transition-colors duration-300 break-all">
              <Mail size={18} className="text-[#005EA8]" /> {CONTACT.email}
            </a>
          </div>

          {/* Credibility */}
          <div>
            <h4 className="text-sm tracking-[0.25em] uppercase text-[#C9A44C] mb-5">Credentials</h4>
            <a
              data-testid="footer-bbb"
              href="https://www.bbb.org/us/tx/round-rock/profile/air-conditioning-contractor/million-air-ac-heating-llc-0825-53745"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mb-4 hover:opacity-90 transition-opacity duration-300"
            >
              <img
                src="/bbb-seal.png"
                alt="BBB Accredited Business, A+ Rating, Million-Air A/C and Heating."
                className="w-[200px] h-auto"
              />
            </a>
            <div className="flex items-center gap-3 text-[#9AA3AF]">
              <Award size={18} className="text-[#C9A44C]" />
              American Standard Dealer
            </div>
          </div>
        </div>

        <div className="hairline my-10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#9AA3AF]">
          <p>&copy; 2026 Million-Air A/C &amp; Heating. All rights reserved.</p>
          <p>millionairhvac.com</p>
        </div>
      </div>
    </footer>
  );
}
